import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './LikeDislikeProject.scss';
var toastMessage = function toastMessage() {
  return /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 g-row--always"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-check-circle me-4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-md-block"
  }, "Got it! We'll use this info to make better project recommendations."), /*#__PURE__*/React.createElement("span", {
    className: "d-block d-md-none body-text-3"
  }, "We\u2019ll use this to make better recommendations."));
};
var LikeDislikeProject = /*#__PURE__*/function (_Component) {
  function LikeDislikeProject(props) {
    var _this;
    _classCallCheck(this, LikeDislikeProject);
    _this = _callSuper(this, LikeDislikeProject, [props]);
    _this.state = {
      isHoveringOverLike: false,
      isHoveringOverDislike: false,
      liked: props.liked,
      disliked: props.disliked
    };
    _this.handleMouseOverLike = _this.handleMouseOverLike.bind(_this);
    _this.handleMouseLeaveLike = _this.handleMouseLeaveLike.bind(_this);
    _this.handleMouseOverDislike = _this.handleMouseOverDislike.bind(_this);
    _this.handleMouseLeaveDislike = _this.handleMouseLeaveDislike.bind(_this);
    _this.like = _this.like.bind(_this);
    _this.dislike = _this.dislike.bind(_this);
    return _this;
  }
  _inherits(LikeDislikeProject, _Component);
  return _createClass(LikeDislikeProject, [{
    key: "handleMouseOverLike",
    value: function handleMouseOverLike() {
      this.setState({
        isHoveringOverLike: true,
        isHoveringOverDislike: false
      });
    }
  }, {
    key: "handleMouseLeaveLike",
    value: function handleMouseLeaveLike() {
      this.setState({
        isHoveringOverLike: false
      });
    }
  }, {
    key: "handleMouseOverDislike",
    value: function handleMouseOverDislike() {
      this.setState({
        isHoveringOverLike: false,
        isHoveringOverDislike: true
      });
    }
  }, {
    key: "handleMouseLeaveDislike",
    value: function handleMouseLeaveDislike() {
      this.setState({
        isHoveringOverDislike: false
      });
    }
  }, {
    key: "like",
    value: function like() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name,
        likePath = _this$props.likePath,
        csrfToken = _this$props.csrfToken;
      return postRequest(likePath, {
        project_id: id
      }, csrfToken).then(function () {
        analyticsTrack('Liked an LikeDislikeProject', {
          location: 'Opportunities Index View',
          id: id,
          project_name: name
        });
        _this2.setState({
          liked: true,
          disliked: false
        });
        toast.success(toastMessage);
      });
    }
  }, {
    key: "dislike",
    value: function dislike() {
      var _this3 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        name = _this$props2.name,
        dislikePath = _this$props2.dislikePath,
        csrfToken = _this$props2.csrfToken;
      return postRequest(dislikePath, {
        project_id: id
      }, csrfToken).then(function () {
        analyticsTrack('Disliked an LikeDislikeProject', {
          location: 'Opportunities Index View',
          id: id,
          project_name: name
        });
        _this3.setState({
          liked: false,
          disliked: true
        });
        toast.success(toastMessage);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state = this.state,
        liked = _this$state.liked,
        disliked = _this$state.disliked,
        isHoveringOverLike = _this$state.isHoveringOverLike,
        isHoveringOverDislike = _this$state.isHoveringOverDislike;
      return /*#__PURE__*/React.createElement("div", {
        className: "like-dislike-container",
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        position: "top-center",
        transition: Slide,
        autoClose: 3000,
        hideProgressBar: true,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: false,
        pauseOnHover: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "like-dislike"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-none d-md-block"
      }, "Would you like to see more projects like this one?"), /*#__PURE__*/React.createElement("div", {
        className: "d-block d-md-none body-text-3"
      }, "Want to see more projects like this?"), /*#__PURE__*/React.createElement("i", {
        className: "ms-3 fa".concat(liked || isHoveringOverLike ? 's' : 'r', " fa-thumbs-up fa-flip-horizontal"),
        onMouseOver: this.handleMouseOverLike,
        onFocus: this.handleMouseOverLike,
        onMouseLeave: this.handleMouseLeaveLike,
        onClick: function onClick() {
          return _this4.like();
        },
        role: "button",
        tabIndex: 0
      }), /*#__PURE__*/React.createElement("i", {
        className: "ms-3 fa".concat(disliked || isHoveringOverDislike ? 's' : 'r', " fa-thumbs-down"),
        onMouseOver: this.handleMouseOverDislike,
        onFocus: this.handleMouseOverDislike,
        onMouseLeave: this.handleMouseLeaveDislike,
        onClick: function onClick() {
          return _this4.dislike();
        },
        role: "button",
        tabIndex: 0
      })));
    }
  }]);
}(Component);
LikeDislikeProject.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  likePath: PropTypes.string.isRequired,
  dislikePath: PropTypes.string.isRequired,
  liked: PropTypes.bool,
  disliked: PropTypes.bool
};
LikeDislikeProject.defaultProps = {
  liked: false,
  disliked: false
};
export default LikeDislikeProject;